import {
    REQUEST_CHECK_LOGIN,
    REQUEST_LOGOUT
} from './mutation-types'

export default {
    [REQUEST_CHECK_LOGIN] (state, receivedData) {
        state.isAuthenticated = receivedData.isAuthenticated
        state.userInfo = receivedData.userInfo
    },
    [REQUEST_LOGOUT] (state) {
        state.isAuthenticated = false
        state.userInfo = {}
    }
}